import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { LogIn, Mail, Lock, Loader2, ShieldCheck } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Loading toast start
    const loadingToast = toast.loading('Verifying credentials...');

    try {
      const res = await api.post('/auth/login', formData);
      
      // Data save karein
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('shopName', res.data.user.shopName);
      localStorage.setItem('userName', res.data.user.name);

      // Success Notification
      toast.success(`Welcome back, ${res.data.user.name}!`, {
        id: loadingToast, // Loading toast ko replace karega
        duration: 3000,
        icon: '🚀',
      });

      // Thora delay taake user success message dekh le
      setTimeout(() => navigate('/dashboard'), 1000);

    } catch (err) {
      // Error Notification (Invalid Credentials ke liye)
      const errorMsg = err.response?.data?.msg || 'Login failed. Please try again.';
      
      toast.error(errorMsg, {
        id: loadingToast, // Loading toast ko error mein badal dega
        style: {
          borderRadius: '15px',
          background: '#333',
          color: '#fff',
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      {/* Toast Container - Isko yahan rakhna lazmi hai */}
      <Toaster position="top-center" reverseOrder={false} />

      <div className="max-w-md w-full bg-white rounded-[3rem] shadow-2xl p-10 border border-gray-100 animate-in fade-in zoom-in duration-500">
        <div className="text-center mb-10">
          <div className="w-16 h-16 bg-black text-white rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-gray-200">
            <ShieldCheck size={32} />
          </div>
          <h2 className="text-4xl font-black text-gray-900 tracking-tight">Seller Login</h2>
          <p className="text-gray-400 mt-2 font-bold uppercase text-[10px] tracking-[0.2em]">Secure Access Only</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div className="space-y-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-2 tracking-widest">Email Address</label>
            <div className="relative group">
              <Mail className="absolute left-4 top-4 text-gray-300 group-focus-within:text-black transition-colors" size={20} />
              <input 
                type="email" required
                className="w-full pl-12 pr-4 py-4 bg-gray-50 rounded-2xl outline-none border-2 border-transparent focus:border-black focus:bg-white transition-all font-bold"
                placeholder="seller@example.com"
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-2 tracking-widest">Password</label>
            <div className="relative group">
              <Lock className="absolute left-4 top-4 text-gray-300 group-focus-within:text-black transition-colors" size={20} />
              <input 
                type="password" required
                className="w-full pl-12 pr-4 py-4 bg-gray-50 rounded-2xl outline-none border-2 border-transparent focus:border-black focus:bg-white transition-all font-bold"
                placeholder="••••••••"
                onChange={(e) => setFormData({...formData, password: e.target.value})}
              />
            </div>
          </div>

          <button 
            disabled={loading}
            className="w-full py-5 bg-black text-white rounded-2xl font-black text-lg shadow-xl hover:bg-gray-800 active:scale-95 transition-all flex items-center justify-center gap-3 mt-4 overflow-hidden relative"
          >
            {loading ? (
              <Loader2 className="animate-spin text-green-400" size={24} />
            ) : (
              <>
                <span>Enter Dashboard</span>
                <LogIn size={20} />
              </>
            )}
          </button>
        </form>

        <p className="text-center mt-10 text-xs text-gray-400 font-bold">
          Forgot password? <span className="text-black hover:underline cursor-pointer">Contact Support</span>
        </p>
      </div>
    </div>
  );
};

export default Login;